import * as tslib_1 from "tslib";
import * as React from 'react';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-common-strings';
var styles = require('./OpenAnotherMailboxDialog.scss');
var OpenAnotherMailboxDialog = /** @class */ (function (_super) {
    tslib_1.__extends(OpenAnotherMailboxDialog, _super);
    function OpenAnotherMailboxDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onTextFieldChange = function (event, newValue) {
            _this.setState({
                targetMailbox: newValue,
            });
        };
        _this.onSubmit = function (event) {
            event.preventDefault();
            _this.dismissWithTarget();
        };
        _this.dismissWithTarget = function () {
            _this.props.onDismiss(_this.state.targetMailbox);
        };
        _this.dismissEmpty = function () {
            _this.props.onDismiss(null);
        };
        _this.state = {
            targetMailbox: '',
        };
        return _this;
    }
    OpenAnotherMailboxDialog.prototype.render = function () {
        return (React.createElement(Dialog, { hidden: false, title: strings.openAnotherMailbox, onDismiss: this.dismissEmpty },
            React.createElement("form", { onSubmit: this.onSubmit },
                React.createElement(TextField, { onChange: this.onTextFieldChange, label: strings.openAnotherMailboxLabel }),
                React.createElement(DialogFooter, null,
                    React.createElement(DefaultButton, { primary: true, text: strings.openAnotherMailboxOpen, onClick: this.dismissWithTarget }),
                    React.createElement(DefaultButton, { primary: false, text: strings.cancelButton, onClick: this.dismissEmpty })),
                React.createElement("input", { className: styles.hideSubmit, type: "submit" }))));
    };
    return OpenAnotherMailboxDialog;
}(React.Component));
export { OpenAnotherMailboxDialog };
//# sourceMappingURL=OpenAnotherMailboxDialog.js.map